// Brand mark (tight-cropped M) with optional wordmark. light=true renders the white variant for dark backgrounds.
export const Logo = ({ size = 40, withText = false, textClass = "", light = false }) => (
  <div className="flex items-center gap-2.5" data-testid="mm-logo">
    <img src={light ? "/mindmoves-mark-white.png" : "/mindmoves-mark.png"} alt="MindMoves" height={size}
         style={{ height: size, width: "auto" }} className="object-contain" />
    {withText && (
      <span className={`font-sans font-extrabold tracking-tight ${textClass}`}>
        MindMoves<span className="text-turq">.ai</span>
      </span>
    )}
  </div>
);

// Full lockup (mark + MINDMOVES.AI wordmark) for the welcome screen.
export const LogoLockup = ({ width = 180, light = false, className = "" }) => (
  <img src={light ? "/mindmoves-lockup-white.png" : "/mindmoves-lockup.png"} alt="MindMoves.ai" width={width}
       style={{ width, height: "auto" }} className={`object-contain ${className}`} data-testid="mm-logo-lockup" />
);

export default Logo;
